import { __awaiter, __asyncValues } from 'tslib';
import QRCodeStyling from 'qr-code-styling';
import { AsyncSubject } from 'rxjs';
import { Injectable, NgModule, Component, ElementRef, Input, ViewEncapsulation, defineInjectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
const Templates = (/**
 * @param {?} name
 * @return {?}
 */
(name) => {
    switch (name) {
        case 'default':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#202020',
                },
                backgroundOptions: {
                    color: "#ffffff",
                }
            }));
        case 'ocean':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    type: 'dots',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#36CDA5'
                            }, {
                                offset: 1,
                                color: '#1582AE'
                            }, {
                                offset: 2,
                                color: '#0277BD'
                            }]
                    }
                },
                backgroundOptions: {
                    color: "#ffffff",
                },
                cornersSquareOptions: {
                    type: 'square'
                }
            }));
        case 'sunflower':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    type: 'dots',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#BB8412'
                            }, {
                                offset: 1,
                                color: '#4D762E'
                            }, {
                                offset: 2,
                                color: '#2F702F'
                            }]
                    }
                },
                backgroundOptions: {
                    color: "#ffffff",
                },
                cornersDotOptions: {
                    color: '#006B3B',
                    type: 'dot'
                },
                cornersSquareOptions: {
                    color: '#006B3B',
                    type: 'extra-rounded'
                }
            }));
        case 'luxury':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    type: 'classy-rounded',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#E29C0F'
                            }, {
                                offset: 1,
                                color: '#913C0C'
                            }, {
                                offset: 2,
                                color: '#732E0C'
                            }]
                    }
                },
                backgroundOptions: {
                    color: "#ffffff",
                },
                cornersDotOptions: {
                    color: '#732E0C',
                    type: 'dot'
                },
                cornersSquareOptions: {
                    color: '#732E0C',
                    type: 'extra-rounded'
                }
            }));
        case 'bitcoin':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#3a3a3a',
                    type: 'dots'
                },
                backgroundOptions: {
                    color: "#ffffff",
                },
                cornersDotOptions: {
                    color: '#ff9900'
                },
                cornersSquareOptions: {
                    type: 'extra-rounded'
                }
            }));
        case 'starbucks':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#3a3a3a',
                    type: 'dots'
                },
                backgroundOptions: {
                    color: "#ffffff",
                },
                cornersDotOptions: {
                    color: '#00643C',
                    type: 'dot'
                },
                cornersSquareOptions: {
                    color: '#00643C',
                    type: 'extra-rounded'
                }
            }));
        case 'angular':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#c3002f',
                    type: 'dots'
                },
                backgroundOptions: {
                    color: "#ffffff",
                }
            }));
        case 'facebook':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#4D72A9',
                    type: 'dots'
                },
                backgroundOptions: {
                    color: "#ffffff",
                }
            }));
        case 'beans':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#416B2C',
                    type: 'dots'
                },
                backgroundOptions: {
                    color: "#ffffff",
                },
                cornersDotOptions: {
                    color: '#60A541',
                    type: 'dot'
                },
                cornersSquareOptions: {
                    type: 'extra-rounded'
                }
            }));
        case 'green':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#006B3B',
                    type: 'dots'
                },
                backgroundOptions: {
                    color: "#ffffff",
                },
                cornersDotOptions: {
                    color: '#006B3B',
                    type: 'dot'
                },
                cornersSquareOptions: {
                    color: '#006B3B',
                    type: 'extra-rounded'
                }
            }));
        case 'sky':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#2c7597',
                    type: 'rounded'
                },
                backgroundOptions: {
                    color: "#ffffff",
                },
            }));
        case 'mosaic':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    type: 'rounded',
                    gradient: {
                        rotation: 190,
                        type: 'linear',
                        colorStops: [{
                                offset: 0,
                                color: '#0277BD'
                            }, {
                                offset: 1,
                                color: '#943A40'
                            }, {
                                offset: 2,
                                color: '#A13535'
                            }]
                    }
                },
                backgroundOptions: {
                    color: "#ffffff",
                }
            }));
        case 'coffee':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#5E4F39',
                    type: 'dots'
                },
                backgroundOptions: {
                    color: "#FAEDE7",
                }
            }));
        case 'vintage':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#2D7363',
                    type: 'extra-rounded'
                },
                backgroundOptions: {
                    color: "#E7E5C5",
                },
                cornersDotOptions: {
                    color: '#BE8C49',
                },
                cornersSquareOptions: {
                    color: '#2D7363',
                }
            }));
        case 'stamp':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#2a3c16',
                    type: 'square'
                },
                backgroundOptions: {
                    color: "#9cc66e",
                },
                cornersDotOptions: {
                    color: '#4c692c',
                },
                cornersSquareOptions: {
                    color: '#2a3c16',
                }
            }));
        case 'chess':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#F4EAA5',
                    type: 'dots'
                },
                backgroundOptions: {
                    color: "#494B49",
                }
            }));
        case 'jungle':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    type: 'classy-rounded',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#84b931'
                            }, {
                                offset: 1,
                                color: '#537234'
                            }, {
                                offset: 2,
                                color: '#537234'
                            }]
                    }
                },
                cornersSquareOptions: {
                    color: '#434343',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#84b931'
                            }, {
                                offset: 1,
                                color: '#537234'
                            }, {
                                offset: 2,
                                color: '#537234'
                            }]
                    }
                }
            }));
        case 'arabic':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    type: 'classy-rounded',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#393939'
                            }, {
                                offset: 1,
                                color: '#393939'
                            }, {
                                offset: 2,
                                color: '#393939'
                            }]
                    }
                },
                cornersSquareOptions: {
                    color: '#434343',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#393939'
                            }, {
                                offset: 1,
                                color: '#72a28b'
                            }, {
                                offset: 2,
                                color: '#72a28b'
                            }]
                    }
                }
            }));
        case 'tea':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    type: 'extra-rounded',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#72b0b4'
                            }, {
                                offset: 1,
                                color: '#035558'
                            }, {
                                offset: 2,
                                color: '#035558'
                            }]
                    }
                },
                cornersSquareOptions: {
                    color: '#434343',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#72b0b4'
                            }, {
                                offset: 1,
                                color: '#035558'
                            }, {
                                offset: 2,
                                color: '#035558'
                            }]
                    }
                }
            }));
        case 'grape':
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    type: 'rounded',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#7076ae'
                            }, {
                                offset: 1,
                                color: '#2a3240'
                            }, {
                                offset: 2,
                                color: '#2a3240'
                            }]
                    }
                },
                cornersSquareOptions: {
                    color: '#434343',
                    gradient: {
                        type: 'radial',
                        colorStops: [{
                                offset: 0,
                                color: '#7b7cb5'
                            }, {
                                offset: 1,
                                color: '#2a3240'
                            }, {
                                offset: 2,
                                color: '#2a3240'
                            }]
                    }
                }
            }));
        default:
            return (/** @type {?} */ ({
                data: '',
                qrOptions: {
                    errorCorrectionLevel: 'Q'
                },
                dotsOptions: {
                    color: '#202020',
                },
                backgroundOptions: {
                    color: "#ffffff",
                }
            }));
    }
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * HAS_OWN_PROPERTY
 * Fix issue vs ng v 6-7-8
 * Optional chaining (?.) just have on ng v 9++
 * eg: HAS_OWN_PROPERTY(config, 'frameOptions.style') // output: boolean
 * \@param obj
 * \@param propertyPath
 * \@return
 * @type {?}
 */
const HAS_OWN_PROPERTY = (/**
 * @param {?} obj
 * @param {?} propertyPath
 * @return {?}
 */
(obj, propertyPath) => {
    /** @type {?} */
    const properties = propertyPath && propertyPath.split(".") || [];
    for (let i = 0; i < properties.length; i++) {
        /** @type {?} */
        let prop = properties[i];
        if (obj && !obj.hasOwnProperty(prop)) {
            return false;
        }
        else if (obj) {
            obj = obj[prop];
        }
    }
    return true;
});
/**
 * drawQrcode
 * @param {?} config
 * @param {?} container
 * @return {?}
 */
function drawQrcode(config, container) {
    // Reject
    if (!config || !container)
        return;
    /** @type {?} */
    const subject = new AsyncSubject();
    /** @type {?} */
    const element = document.createElement("div");
    /**
     * QRCODE_NONE_FRAME
     * \@return
     * @type {?}
     */
    const QRCODE_NONE_FRAME = (/**
     * @return {?}
     */
    () => {
        if (HAS_OWN_PROPERTY(config, 'frameOptions')) {
            return false;
        }
        else {
            /** @type {?} */
            const encodeConfig = (/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                let deep = config && JSON.parse(JSON.stringify(config));
                return Object.assign({ data: ((/** @type {?} */ (window))).unescape(encodeURIComponent(deep && deep.data || '')) }, deep);
            })
            // removeChild
            ;
            // removeChild
            while (container.firstChild) {
                container.removeChild(container.lastChild);
            }
            /** @type {?} */
            const CR = new QRCodeStyling((/** @type {?} */ (encodeConfig())));
            // append to container
            CR.append(container);
            return true;
        }
    });
    /** @type {?} */
    const styleName = HAS_OWN_PROPERTY(config, 'frameOptions.style') ? config.frameOptions.style : 'F_020';
    /** @type {?} */
    const height = HAS_OWN_PROPERTY(config, 'frameOptions.height') ? config.frameOptions.height : 300;
    /** @type {?} */
    const width = HAS_OWN_PROPERTY(config, 'frameOptions.width') ? config.frameOptions.width : 300;
    /** @type {?} */
    const x = HAS_OWN_PROPERTY(config, 'frameOptions.x') ? config.frameOptions.x : 50;
    /** @type {?} */
    const y = HAS_OWN_PROPERTY(config, 'frameOptions.y') ? config.frameOptions.y : 50;
    /**
     * ADD_FRAME_SVG_TO_ELEMENT
     * \@return
     * @type {?}
     */
    const ADD_FRAME_SVG_TO_ELEMENT = (/**
     * @return {?}
     */
    () => {
        /** @type {?} */
        const http = fetch(`https://raw.githubusercontent.com/id1945/ngx-qrcode-styling/master/svg/${styleName}.svg`, { method: 'GET' });
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => {
            http.then((/**
             * @param {?} response
             * @return {?}
             */
            response => response.text())).then((/**
             * @param {?} result
             * @return {?}
             */
            result => {
                if (result !== "404: Not Found") {
                    upgradeSvg(result);
                }
                resolve(result);
            })).catch((/**
             * @param {?} error
             * @return {?}
             */
            error => {
                console.error(error);
                reject(error);
            }));
        }));
    });
    /** @type {?} */
    const upgradeSvg = (/**
     * @param {?} result
     * @return {?}
     */
    (result) => {
        /** @type {?} */
        const parser = new DOMParser();
        /** @type {?} */
        const doc = parser.parseFromString(result, "image/svg+xml");
        if (doc) {
            /** @type {?} */
            const svgEl = ((/** @type {?} */ (doc.documentElement.children)))[styleName + '_svg'];
            if (!svgEl)
                return;
            /** @type {?} */
            const textEls = svgEl.getElementsByClassName("frame-text");
            /** @type {?} */
            const contentEls = svgEl.getElementsByClassName("frame-content");
            /** @type {?} */
            const containerEls = svgEl.getElementsByClassName("frame-container");
            HAS_OWN_PROPERTY(config, 'frameOptions.background') && svgEl.setAttribute('style', `background: ${config.frameOptions.background};${svgEl.getAttribute('style')}`);
            /** @type {?} */
            const updateStyle = (/**
             * @param {?} el
             * @param {?} config
             * @return {?}
             */
            (el, config) => {
                if (el) {
                    for (const key in config) {
                        if (((/** @type {?} */ (['x', 'y', 'transform']))).includes(key)) {
                            el.setAttribute(key, config && config[key]);
                        }
                        else if (((/** @type {?} */ (['textContent']))).includes(key)) {
                            el[key] = config && config[key];
                        }
                        else {
                            el.style[key] = config && config[key];
                        }
                    }
                }
            });
            /** @type {?} */
            const createElementNS = (/**
             * @param {?} config
             * @return {?}
             */
            (config) => {
                /** @type {?} */
                const svgNS = "http://www.w3.org/2000/svg";
                /** @type {?} */
                const newText = document.createElementNS(svgNS, "text");
                updateStyle(newText, config);
                svgEl.appendChild(newText);
            });
            if (HAS_OWN_PROPERTY(config, 'frameOptions.texts')) {
                Object.assign([], config.frameOptions.texts).forEach((/**
                 * @param {?} text
                 * @param {?} i
                 * @return {?}
                 */
                (text, i) => {
                    /** @type {?} */
                    const el = Object.assign([], textEls)[i];
                    el ? updateStyle(el, text) : createElementNS(text);
                }));
            }
            if (HAS_OWN_PROPERTY(config, 'frameOptions.containers')) {
                Object.assign([], containerEls).forEach((/**
                 * @param {?} el
                 * @param {?} i
                 * @return {?}
                 */
                (el, i) => {
                    updateStyle(el, config.frameOptions.containers[i]);
                }));
            }
            if (HAS_OWN_PROPERTY(config, 'frameOptions.contents')) {
                Object.assign([], contentEls).forEach((/**
                 * @param {?} el
                 * @param {?} i
                 * @return {?}
                 */
                (el, i) => {
                    updateStyle(el, config.frameOptions.contents[i]);
                }));
            }
            element.appendChild(doc.documentElement);
        }
    })
    /**
     * UPDATE_POSITION_QRCODE_ON_FRAME
     * @returns HTMLElement
     */
    ;
    /**
     * UPDATE_POSITION_QRCODE_ON_FRAME
     * \@return HTMLElement
     * @type {?}
     */
    const UPDATE_POSITION_QRCODE_ON_FRAME = (/**
     * @return {?}
     */
    () => {
        /** @type {?} */
        const addsvg = element.querySelector('.addsvg');
        addsvg && addsvg.setAttribute("transform", `translate(${x},${y})`);
        return (/** @type {?} */ (addsvg));
    })
    /**
     * UPDATE_ROTATE_SCALE_QRCODE_ON_FRAME
     * @param svg
     * @returns void
     */
    ;
    /**
     * UPDATE_ROTATE_SCALE_QRCODE_ON_FRAME
     * \@param svg
     * \@return void
     * @type {?}
     */
    const UPDATE_ROTATE_SCALE_QRCODE_ON_FRAME = (/**
     * @param {?} svg
     * @return {?}
     */
    (svg) => {
        if (HAS_OWN_PROPERTY(config, 'rotate') && svg) {
            Object.assign([], svg.childNodes[0].childNodes).forEach((/**
             * @param {?} node
             * @return {?}
             */
            (node) => {
                if (node.nodeName === 'rect') {
                    node.style.transformOrigin = `50% 50%`;
                    node.style.transform = `rotate(${config && config.rotate || 0}deg)`;
                }
            }));
        }
        if (HAS_OWN_PROPERTY(config, 'scale') && svg) {
            Object.assign([], svg.childNodes[0].childNodes).forEach((/**
             * @param {?} node
             * @return {?}
             */
            (node) => {
                if (node.nodeName === 'rect') {
                    node.style.scale = config && config.scale || 0;
                }
            }));
        }
    })
    /**
     * CREATE_QRCODE_INTO_FRAME
     * @param addsvg
     * @returns
     */
    ;
    /**
     * CREATE_QRCODE_INTO_FRAME
     * \@param addsvg
     * \@return
     * @type {?}
     */
    const CREATE_QRCODE_INTO_FRAME = (/**
     * @param {?} addsvg
     * @return {?}
     */
    (addsvg) => {
        /** @type {?} */
        const defaultConfig = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            let deep = config && JSON.parse(JSON.stringify(config));
            deep = Object.assign({}, deep, { type: 'svg', data: ((/** @type {?} */ (window))).unescape(encodeURIComponent(deep && deep.data || '')) });
            delete deep.frameOptions;
            delete deep.template;
            return deep;
        })
        // removeChild
        ;
        // removeChild
        while (container.firstChild) {
            container.removeChild(container.lastChild);
        }
        /** @type {?} */
        const CR = new QRCodeStyling((/** @type {?} */ (defaultConfig())));
        return HAS_OWN_PROPERTY(CR, '_svgDrawingPromise') && CR._svgDrawingPromise.then((/**
         * @return {?}
         */
        () => {
            CR.append(addsvg);
        })).catch((/**
         * @param {?} error
         * @return {?}
         */
        (error) => console.error(error)));
    })
    /**
     * QRCODE_TYPE_SVG
     * @returns
     */
    ;
    /**
     * QRCODE_TYPE_SVG
     * \@return
     * @type {?}
     */
    const QRCODE_TYPE_SVG = (/**
     * @return {?}
     */
    () => {
        if (config && config.type === 'svg') {
            UPDATE_SIZE_SVG();
            container.appendChild(element);
            return true;
        }
        return false;
    })
    /**
     * CREATE_CANVAS_WITH_SIZE
     * @returns
     */
    ;
    /**
     * CREATE_CANVAS_WITH_SIZE
     * \@return
     * @type {?}
     */
    const CREATE_CANVAS_WITH_SIZE = (/**
     * @return {?}
     */
    () => {
        /** @type {?} */
        const canvas = document.createElement('canvas');
        canvas.height = height;
        canvas.width = width;
        container.appendChild(canvas);
        return canvas;
    })
    /**
     * ELEMENT_CONVERT_TO_BASE64
     * @param s1
     * @returns
     */
    ;
    /**
     * ELEMENT_CONVERT_TO_BASE64
     * \@param s1
     * \@return
     * @type {?}
     */
    const ELEMENT_CONVERT_TO_BASE64 = (/**
     * @param {?} s1
     * @return {?}
     */
    (s1) => {
        /** @type {?} */
        let b64 = "data:image/svg+xml;base64,";
        /** @type {?} */
        const xml = s1 && new XMLSerializer().serializeToString(s1);
        return b64 += xml && btoa(unescape(encodeURIComponent(xml)));
    })
    /**
     * UPDATE_SIZE_SVG
     * @returns
     */
    ;
    /**
     * UPDATE_SIZE_SVG
     * \@return
     * @type {?}
     */
    const UPDATE_SIZE_SVG = (/**
     * @return {?}
     */
    () => {
        /** @type {?} */
        const s1 = element.querySelector(`#${styleName}_svg`);
        s1 && s1.setAttribute('height', `${height}px`);
        s1 && s1.setAttribute('width', `${width}px`);
        return (/** @type {?} */ (s1));
    })
    /**
     * BASE64_TO_BLOB
     * @param base64Image
     * @returns
     */
    ;
    /**
     * BASE64_TO_BLOB
     * \@param base64Image
     * \@return
     * @type {?}
     */
    const BASE64_TO_BLOB = (/**
     * @param {?} base64Image
     * @return {?}
     */
    (base64Image) => {
        // Split into two parts
        /** @type {?} */
        const parts = base64Image.split(";base64,");
        // Hold the content type
        /** @type {?} */
        const imageType = parts[0].split(":")[1];
        // Decode Base64 string
        /** @type {?} */
        const decodedData = window.atob(parts[1]);
        // Create UNIT8ARRAY of size same as row data length
        /** @type {?} */
        const uInt8Array = new Uint8Array(decodedData.length);
        // Insert all character code into uInt8Array
        for (let i = 0; i < decodedData.length; ++i) {
            uInt8Array[i] = decodedData.charCodeAt(i);
        }
        // Return BLOB image after conversion
        return new Blob([uInt8Array], { type: imageType });
    })
    /**
     * CREATE_IMAGE
     */
    ;
    /**
     * CREATE_IMAGE
     * @type {?}
     */
    const CREATE_IMAGE = (/**
     * @return {?}
     */
    () => {
        /** @type {?} */
        const img = new Image();
        /** @type {?} */
        const ctx = CREATE_CANVAS_WITH_SIZE().getContext("2d");
        img.onload = (/**
         * @return {?}
         */
        function () {
            ctx && ctx.drawImage(img, 0, 0);
        });
        /** @type {?} */
        const blob = BASE64_TO_BLOB(ELEMENT_CONVERT_TO_BASE64(UPDATE_SIZE_SVG()));
        /** @type {?} */
        const blobUrl = URL.createObjectURL(blob);
        img.src = blobUrl;
    })
    /**
     * MAIN
     */
    ;
    /**
     * MAIN
     */
    ((/**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function* () {
            if (QRCODE_NONE_FRAME()) {
                subject.next({ config, container });
                subject.complete();
                return; // Mode qrcode basic
            }
            else {
                yield ADD_FRAME_SVG_TO_ELEMENT();
                /** @type {?} */
                const ADDSVG = UPDATE_POSITION_QRCODE_ON_FRAME();
                yield CREATE_QRCODE_INTO_FRAME(ADDSVG);
                UPDATE_ROTATE_SCALE_QRCODE_ON_FRAME(ADDSVG);
                if (QRCODE_TYPE_SVG()) {
                    // Mode qrcode + frame type svg
                    subject.next({ config, container });
                    subject.complete();
                }
                else {
                    // Mode qrcode + frame type canvas
                    CREATE_IMAGE();
                    subject.next({ config, container });
                    subject.complete();
                }
            }
        });
    }))();
    return subject;
}
/**
 * defaultTemplate
 * \@param config
 * \@return
 * @type {?}
 */
const defaultTemplate = (/**
 * @param {?=} config
 * @return {?}
 */
(config) => {
    /** @type {?} */
    let deep = config && JSON.parse(JSON.stringify(config));
    return HAS_OWN_PROPERTY(config, 'template') ? Object.assign({}, Templates(config.template.toLocaleLowerCase()), deep) : deep;
});
/**
 * deepUpdate
 * \@param config
 * \@param configUpdate
 * \@return
 * @type {?}
 */
const deepUpdate = (/**
 * @param {?} config
 * @param {?} configUpdate
 * @return {?}
 */
(config, configUpdate) => __awaiter(this, void 0, void 0, function* () {
    var e_1, _a;
    /** @type {?} */
    const origin = config && JSON.parse(JSON.stringify(config));
    /** @type {?} */
    let clone = Object.assign({}, origin, configUpdate);
    /** @type {?} */
    const keys = ['frameOptions', 'qrOptions', 'imageOptions', 'dotsOptions', 'cornersSquareOptions', 'cornersDotOptions', 'backgroundOptions'];
    try {
        for (var keys_1 = __asyncValues(keys), keys_1_1; keys_1_1 = yield keys_1.next(), !keys_1_1.done;) {
            const key = keys_1_1.value;
            if (HAS_OWN_PROPERTY(configUpdate, key)) {
                /** @type {?} */
                const update = {
                    [key]: Object.assign({}, origin && origin[key], ((/** @type {?} */ (configUpdate)))[key])
                };
                clone = Object.assign({}, clone, update);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) yield _a.call(keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return clone;
}));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxQrcodeStylingService {
    /**
     * create
     * @param {?} config
     * @param {?} container
     * @return {?}
     */
    create(config, container) {
        return drawQrcode(defaultTemplate(config), container);
    }
    /**
     * update
     * @param {?} config
     * @param {?} configUpdate
     * @param {?} container
     * @return {?}
     */
    update(config, configUpdate, container) {
        /** @type {?} */
        const subject = new AsyncSubject();
        ((/**
         * @return {?}
         */
        function () {
            return __awaiter(this, void 0, void 0, function* () {
                /** @type {?} */
                const conf = yield deepUpdate(defaultTemplate(config), defaultTemplate(configUpdate));
                drawQrcode(conf, container).subscribe((/**
                 * @param {?} s
                 * @return {?}
                 */
                s => {
                    subject.next(s);
                    subject.complete();
                }));
            });
        }))();
        return subject;
    }
    /**
     * download image
     * @param {?} container
     * @param {?=} fileName
     * @param {?=} timeout
     * @return {?}
     */
    download(container, fileName = '', timeout = 0) {
        /** @type {?} */
        const subject = new AsyncSubject();
        /** @type {?} */
        const _fileName = (/**
         * @param {?} type
         * @return {?}
         */
        (type) => {
            if (!fileName) {
                fileName = `ngx_qrcode_styling_${Date.now()}.${type}`;
            }
        });
        /** @type {?} */
        const _download = (/**
         * @param {?} dataURL
         * @return {?}
         */
        (dataURL) => {
            /** @type {?} */
            const link = document.createElement('a');
            link.download = fileName;
            link.href = dataURL;
            link.click();
            link.remove();
        });
        /** @type {?} */
        const _complete = (/**
         * @param {?} url
         * @return {?}
         */
        (url) => {
            if (url) {
                _download(url);
                subject.next({ fileName, container, url: url });
                subject.complete();
            }
            else {
                subject.error('Container not found!');
                subject.complete();
            }
        });
        setTimeout((/**
         * @return {?}
         */
        () => {
            if (!container) {
                _complete('');
            }
            else {
                /** @type {?} */
                const canvas = container.querySelector('canvas');
                if (canvas) {
                    _fileName('png');
                    /** @type {?} */
                    const typeImg = fileName ? fileName.split('.').slice(-1).toString() : 'png';
                    canvas.toBlob((/**
                     * @param {?} blob
                     * @return {?}
                     */
                    (blob) => _complete(URL.createObjectURL(blob))), 'image/' + typeImg);
                }
                else {
                    /** @type {?} */
                    const svg = container.querySelector('svg');
                    if (svg) {
                        _fileName('svg');
                        /** @type {?} */
                        const svgData = svg.outerHTML;
                        /** @type {?} */
                        const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
                        /** @type {?} */
                        const svgUrl = URL.createObjectURL(svgBlob);
                        _complete(svgUrl);
                    }
                    else {
                        _complete('');
                    }
                }
            }
        }), timeout);
        return subject;
    }
}
NgxQrcodeStylingService.ɵfac = function NgxQrcodeStylingService_Factory(t) { return new (t || NgxQrcodeStylingService)(); };
NgxQrcodeStylingService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxQrcodeStylingService, factory: NgxQrcodeStylingService.ɵfac, providedIn: 'root' });
/** @nocollapse */ NgxQrcodeStylingService.ngInjectableDef = defineInjectable({ factory: function NgxQrcodeStylingService_Factory() { return new NgxQrcodeStylingService(); }, token: NgxQrcodeStylingService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxQrcodeStylingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxQrcodeStylingComponent {
    /**
     * @param {?} canvas
     * @param {?} service
     */
    constructor(canvas, service) {
        this.canvas = canvas;
        this.service = service;
        /**
         * TemplateType
         */
        this.template = 'default';
        /**
         * number
         */
        this.scale = 0;
        /**
         * string
         */
        this.rotate = 0;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.canvas) {
            /**
             * @Input override
             */
            if (this.template)
                this.config = Object.assign({}, this.config, { template: this.template });
            if (this.type)
                this.config = Object.assign({}, this.config, { type: this.type });
            if (this.shape)
                this.config = Object.assign({}, this.config, { shape: this.shape });
            if (this.width)
                this.config = Object.assign({}, this.config, { width: this.width });
            if (this.height)
                this.config = Object.assign({}, this.config, { height: this.height });
            if (this.margin)
                this.config = Object.assign({}, this.config, { margin: this.margin });
            if (this.data)
                this.config = Object.assign({}, this.config, { data: this.data });
            if (this.image)
                this.config = Object.assign({}, this.config, { image: this.image });
            if (this.scale)
                this.config = Object.assign({}, this.config, { scale: this.scale });
            if (this.rotate)
                this.config = Object.assign({}, this.config, { rotate: this.rotate });
            if (this.frameOptions)
                this.config = Object.assign({}, this.config, { frameOptions: this.frameOptions });
            if (this.qrOptions)
                this.config = Object.assign({}, this.config, { qrOptions: this.qrOptions });
            if (this.imageOptions)
                this.config = Object.assign({}, this.config, { imageOptions: this.imageOptions });
            if (this.dotsOptions)
                this.config = Object.assign({}, this.config, { dotsOptions: this.dotsOptions });
            if (this.cornersSquareOptions)
                this.config = Object.assign({}, this.config, { cornersSquareOptions: this.cornersSquareOptions });
            if (this.cornersDotOptions)
                this.config = Object.assign({}, this.config, { cornersDotOptions: this.cornersDotOptions });
            if (this.backgroundOptions)
                this.config = Object.assign({}, this.config, { backgroundOptions: this.backgroundOptions });
            this.create(this.config);
        }
    }
    /**
     * create
     * @param {?} config
     * @return {?}
     */
    create(config) {
        return this.service.create(config, this.canvas.nativeElement);
    }
    /**
     * update
     * @param {?} config
     * @param {?} configUpdate
     * @return {?}
     */
    update(config, configUpdate) {
        return this.service.update(config, configUpdate, this.canvas.nativeElement);
    }
    /**
     * download image
     * @param {?=} fileName eg: demo.png
     * @param {?=} timeout
     * @return {?}
     */
    download(fileName, timeout = 0) {
        return this.service.download(this.canvas.nativeElement, fileName, timeout);
    }
}
NgxQrcodeStylingComponent.ɵfac = function NgxQrcodeStylingComponent_Factory(t) { return new (t || NgxQrcodeStylingComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(NgxQrcodeStylingService)); };
NgxQrcodeStylingComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxQrcodeStylingComponent, selectors: [["ngx-qrcode-styling"]], inputs: { template: "template", scale: "scale", rotate: "rotate", config: "config", type: "type", shape: "shape", width: "width", height: "height", margin: "margin", data: "data", image: "image", frameOptions: "frameOptions", qrOptions: "qrOptions", imageOptions: "imageOptions", dotsOptions: "dotsOptions", cornersSquareOptions: "cornersSquareOptions", cornersDotOptions: "cornersDotOptions", backgroundOptions: "backgroundOptions" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function NgxQrcodeStylingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
NgxQrcodeStylingComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgxQrcodeStylingService }
];
NgxQrcodeStylingComponent.propDecorators = {
    config: [{ type: Input }],
    template: [{ type: Input }],
    type: [{ type: Input }],
    shape: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    margin: [{ type: Input }],
    data: [{ type: Input }],
    image: [{ type: Input }],
    scale: [{ type: Input }],
    rotate: [{ type: Input }],
    frameOptions: [{ type: Input }],
    qrOptions: [{ type: Input }],
    imageOptions: [{ type: Input }],
    dotsOptions: [{ type: Input }],
    cornersSquareOptions: [{ type: Input }],
    cornersDotOptions: [{ type: Input }],
    backgroundOptions: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxQrcodeStylingComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-qrcode-styling',
                template: '<ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: NgxQrcodeStylingService }]; }, { template: [{
            type: Input
        }], scale: [{
            type: Input
        }], rotate: [{
            type: Input
        }], config: [{
            type: Input
        }], type: [{
            type: Input
        }], shape: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], margin: [{
            type: Input
        }], data: [{
            type: Input
        }], image: [{
            type: Input
        }], frameOptions: [{
            type: Input
        }], qrOptions: [{
            type: Input
        }], imageOptions: [{
            type: Input
        }], dotsOptions: [{
            type: Input
        }], cornersSquareOptions: [{
            type: Input
        }], cornersDotOptions: [{
            type: Input
        }], backgroundOptions: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxQrcodeStylingModule {
}
NgxQrcodeStylingModule.ɵfac = function NgxQrcodeStylingModule_Factory(t) { return new (t || NgxQrcodeStylingModule)(); };
NgxQrcodeStylingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxQrcodeStylingModule });
NgxQrcodeStylingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        NgxQrcodeStylingService
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxQrcodeStylingModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NgxQrcodeStylingComponent
                ],
                exports: [
                    NgxQrcodeStylingComponent
                ],
                providers: [
                    NgxQrcodeStylingService
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxQrcodeStylingModule, { declarations: [NgxQrcodeStylingComponent], exports: [NgxQrcodeStylingComponent] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { Templates, NgxQrcodeStylingService, NgxQrcodeStylingComponent, NgxQrcodeStylingModule };

